import BLOG_ROUTES from './blog';
import EVENTS_ROUTES from './events';
import PROJECTS_ROUTES from './projects';
import PUBLIC_ROUTES from './public';

const ROUTES = {
  BLOG: BLOG_ROUTES,
  EVENTS: EVENTS_ROUTES,
  PROJECTS: PROJECTS_ROUTES,
  PUBLIC: PUBLIC_ROUTES,
};

export default ROUTES;
